import { render } from "./AdminOrder.vue?vue&type=template&id=02dc27f5"
import script from "./AdminOrder.vue?vue&type=script&lang=js"
export * from "./AdminOrder.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__